export default "__VITE_ASSET__7f72db86__"